import http from "./httpService";
import { apiUrl } from "../config";

export const getDelivery = (deliveryId) => {
  return http.get(`${apiUrl}Delivery/GetDelivery?deliveryId=${deliveryId}`);
};
export const checkInvoiceAlreadyExists = (invoiceNumber) => {
  return http.get(`${apiUrl}InvoiceMast/CheckIfDuplicateInvoice`, {
    params: { invoiceNumber: invoiceNumber },
  });
};
export const postOrder = (orderRequest) => {
  return http.post(`${apiUrl}Delivery/PostOrder`, orderRequest);
};

export const getExistingOrder = (deliveryId) => {
  return http.get(`${apiUrl}Delivery/GetExistingOrder`, {
    params: { deliveryId },
  });
};

//reports
export const getShipmentAnalysisReport = (
  fromDate,
  toDate,
  route,
  cityAndState,
  reportType,
) => {
  return http.get(
    `${apiUrl}Delivery/DeliveryReport?fromDate=${fromDate}&toDate=${toDate}&route=${route}&citySt=${cityAndState}&type=s&reportType=${reportType}`,
    {
      responseType: "blob",
    },
    { type: "application/vnd.ms-excel" },
  );
};

export const getShortageReport = (dateFrom, dateTo) => {
  return http.get(
    `${apiUrl}Delivery/GetShortageReport?fromDate=${dateFrom}&toDate=${dateTo}`,
  );
};

//end reports

export const getDeliveryHistory = (fromDate, toDate, isClient, timeout = 0) => {
  return http.get(`${apiUrl}Delivery/DeliveryHistory`, {
    params: { from: fromDate, to: toDate, isClient },
    timeout,
  });
};

// convert sortings and filters to backend expected format
// each sorting: { id: "columnName", desc: true/false } -> { id: "ColumnName", desc: true/false }
// each filter: { id: "columnName", value: "filterValue" } -> { id: "ColumnName", value: "filterValue" }
//

export const getOrderHistorySearch = ({
  isClient,
  searchBy,
  fromDate,
  toDate,
  pageIndex = 0,
  pageSize = 10,
  columnsSorting = [],
  columnsFilter = [],
  timeout = 0,
  selected = [],
  tableMode,
  skipCXTStatus = false,
}) =>
  http.get(`${apiUrl}Delivery/Orders`, {
    params: {
      searchBy,
      pageIndex,
      pageSize,
      columnsSorting,
      columnsFilter,
      fromDate,
      toDate,
      isClient,
      selectedInvoicesOrBarcodes: selected,
      tableMode,
      skipCXTStatus,
    },
    timeout,
  });

export const getAllOrders = ({
  isClient,
  searchBy,
  fromDate,
  toDate,
  timeout = 0,
  selected = [],
  tableMode,
}) =>
  http.get(`${apiUrl}Delivery/Orders`, {
    params: {
      searchBy,
      fromDate,
      toDate,
      isClient,
      selectedInvoicesOrBarcodes: selected,
      tableMode,
    },
    timeout,
  });

export const getDeliveriesByBarcodes = (barcodes, timeout = 0) => {
  //pass the barcodes array in the format of a get request (there is a helper function in utilities.js to convert an array to a string in the correct format)
  //backend parameter name is barcode, pass that into the second paramater of the above utility function
  return http.get(`${apiUrl}Delivery/DeliveryByBarcode?${barcodes}`, {
    timeout,
  });
};
export const getDeliveriesByInvoices = (invoiceNumbers, timeout = 0) => {
  //pass the array in the format of a get request (there is a helper function in utilities.js to convert an array to a string in the correct format)
  //the backend paramter is invoiceNumber, pass that into the second  paramater of the above utility function
  return http.get(`${apiUrl}Delivery/GetDeliveryByInvoice?${invoiceNumbers}`, {
    timeout,
  });
};

export const getCXTDeliveryHistory = (custId, startDate, endDate) => {
  return http.get(`${apiUrl}Delivery/ReportOrderSummary`, {
    params: {
      custId,
      startDate,
      endDate,
    },
  });
};

export const getOrderDetails = (
  deliveryId,
  invoiceNumber,
  orderCreationDate,
  isClient,
) => {
  //backend no longer uses invoice number, as it was retrieving data for different orders that had the same invoice number
  return http.get(`${apiUrl}Delivery/OrderDetails`, {
    params: {
      deliveryId,
      invoiceNumber,
      orderDate: orderCreationDate,
      isClient,
    },
  });
};

export const getNotScannedStatus = (barcodeList, isClientFlag) => {
  //new endpoint to fix all the erroneous "Not Scanned" statuses that the CXT API based endpoints give(because they don't look at unexpected scans).
  return http.post(`${apiUrl}Delivery/GetNotScannedStatus`, barcodeList, {
    params: { flag: isClientFlag },
  });
};

export const getOrderComments = (deliveryId, isClientFlag) => {
  return http.get(`${apiUrl}Delivery/GetOrderComments`, {
    params: {
      deliveryId,
      flag: isClientFlag,
    },
  });
};

export const getOrderDetailsOld = (deliveryId, isClient) => {
  return http.get(`${apiUrl}Delivery/OrderDetailsOld`, {
    params: { deliveryId, isClient },
  });
};

export const getParcelTracking = (barcode, creationDate, isClient) => {
  return http.get(`${apiUrl}Delivery/GetParcelTracking`, {
    params: { barcode, creationDate, isClient },
  });
};
export const getAdditionalParcelTracking = (parcelId, isClient) => {
  return http.get(`${apiUrl}Delivery/AdditionalParcelTracking`, {
    params: { parcelId, isClient },
  });
};
export const getPublicTrackerAdditionalParcelTracking = (parcelId) => {
  return http.get(`${apiUrl}Delivery/GetPublicTrackerAdditionalInformation`, {
    params: { parcelId },
  });
};
export const getDeliveryHistoryCXT = (custId, startDate, endDate) => {
  return http.get(`${apiUrl}Delivery/ReportOrderSummary`, {
    params: { custId: custId, startDate: startDate, endDate: endDate },
  });
};

export const getExportOrderHistory = (fromDate, toDate) => {
  return http.get(`${apiUrl}Delivery/ExportOrderHistory`, {
    params: { from: fromDate, to: toDate },
    responseType: "blob",
  });
};

export const voidOrder = (deliveryId) => {
  return http.delete(`${apiUrl}Delivery/VoidOrder`, { params: { deliveryId } });
};

export const getParcelImage = (fileId, isClient) => {
  return http.get(`${apiUrl}Delivery/GetParcelImage`, {
    params: { fileId, isClient },
  });
};
export const getPublicTrackerParcelImage = (fileId) => {
  return http.get(`${apiUrl}Delivery/GetPublicTrackerParcelImage`, {
    params: { fileId },
  });
};
export const getLabelsForMultipleDeliveries = (
  deliveryIdsString,
  isBatchPrint,
  IsClient,
) => {
  // const queryString = new URLSearchParams();
  // queryString.append("deliveryIds", deliveryIds);
  // const fullUrl = `${apiUrl}Delivery/GetLabelsForMultipleDeliveries?${queryString.toString()}`;
  // return http.get(fullUrl, { responseType: "blob" });
  return http.post(
    `${apiUrl}Delivery/GetLabelsForMultipleDeliveries`,
    { deliveryId: deliveryIdsString, isBatch: isBatchPrint, IsClient },
    { responseType: "blob" },
  );
};
export const getLabelsForCDKDeliveries = (
  deliveryIdsString,
  isBatchPrint,
  IsClient,
) => {
  // const queryString = new URLSearchParams();
  // queryString.append("deliveryIds", deliveryIds);
  // const fullUrl = `${apiUrl}Delivery/GetLabelsForMultipleDeliveries?${queryString.toString()}`;
  // return http.get(fullUrl, { responseType: "blob" });
  return http.post(
    `${apiUrl}Delivery/GetLabelsForCdkOrder`,
    { deliveryId: deliveryIdsString, isBatch: isBatchPrint, IsClient },
    { responseType: "blob" },
  );
};

export const printManifest = (date, alreadyPrinted) => {
  //print manifest for specified date
  return http.get(`${apiUrl}Delivery/GetNetworkManifest`, {
    params: {
      dateToLookFor: date,
      alreadyPrinted,
    },
    responseType: "blob",
  });
};

export const simplifiedManifest = (date, alreadyPrinted) =>
  http.get(`${apiUrl}Delivery//GetSimplifiedNetworkManifest`, {
    params: {
      dateToLookFor: date,
      alreadyPrinted,
    },
    responseType: "blob",
  });

export const postReturn = (returnRequest) => {
  return http.post(`${apiUrl}Delivery/PostReturn`, returnRequest);
};

export const postBuyout = (buyoutRequest) => {
  // console.log(buyoutRequest);
  return http.post(`${apiUrl}Delivery/PostBuyout`, buyoutRequest);
};

export const getBarcodeSuggestions = (barcodeSearchTerm, signal) => {
  return http.get(`${apiUrl}Delivery/GetBarcodes`, {
    params: {
      barcodeSearch: barcodeSearchTerm,
    },
    signal,
  });
};
export const getInvoiceSearchSuggestions = (invoiceSearchTerm, signal) => {
  return http.get(`${apiUrl}Delivery/GetInvoiceSearchSuggestions`, {
    params: {
      invoiceNumberSuggestion: invoiceSearchTerm,
    },
    signal,
  });
};

export const getCXTOrderByBarcode = (
  barcodeArray,
  // fromDate, toDate
) => {
  return http.post(`${apiUrl}Cxt/GetCxtOrderByBarcode`, barcodeArray);
  // startDate: fromDate,
  // endDate: toDate,
};
export const getDeliveryByBOL = (
  clientId,
  listOfInvoicesOrReferencesToSearch,
  searchType, //0 to search by invoice, 1 to search by reference number
) => {
  return http.post(`${apiUrl}Delivery/GetDeliveryByBOL`, {
    clientId: clientId,
    searchCriteria: listOfInvoicesOrReferencesToSearch,
    searchType: searchType,
  });
};

export const postCustomerReturnRequest = (returnRequest) =>
  http.post(`${apiUrl}Delivery/PostCustomerReturnRequest`, returnRequest);

export const postManualReturn = (returnRequest) =>
  http.post(`${apiUrl}Delivery/PostManualCustomerReturn`, returnRequest);
